import { __assign, __rest } from "tslib";
import React from 'react';
import VeltNotificationsPanelContentAllListWireframe from './VeltNotificationsPanelContentAllListWireframe/VeltNotificationsPanelContentAllListWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltNotificationsPanelContentAllWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-all-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentAllWireframe.List = VeltNotificationsPanelContentAllListWireframe;
export default VeltNotificationsPanelContentAllWireframe;
